export default defineNuxtRouteMiddleware(async (to, from) => {
  const useBreadcrumbs = useBreadcrumbsStore()
  await useBreadcrumbs.set([])
  useBreadcrumbs.hide()
})
